
import { Vue, Component } from 'vue-property-decorator'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import ButtonContained from '@/components/common/buttons/ButtonContained.vue'

@Component({
  components: {
    ValidationProvider,
    ValidationObserver,
    ButtonContained
  }
})
export default class Authentication extends Vue {
  $refs!: {
    observer: InstanceType<typeof ValidationObserver>;
    email: InstanceType<typeof ValidationProvider>;
    password: InstanceType<typeof ValidationProvider>;
  }

  private resetPassword() {
    this.$emit('set-view', 'resetPassword')
  }

  private data = {
    email: '',
    password: '',
    remember: false
  }

  private submit() {
    this.$refs.observer.validate().then((success) => {
      if (!success) { return }

      const form = new FormData()

      form.append('email', this.data.email)
      form.append('password', this.data.password)

      if (this.data.remember) {
        form.append('remember', this.data.remember.toString())
      }

      this.$auth.loginWith('local', { data: form })
        .then(() => this.$emit('login-success'))
        .catch((err: Axios.AxiosError) => {
          if (!err.response) { return }
          const error = err.response.data && err.response.data.error

          if (!error) { return }

          Object.keys(error).forEach((errFieldName) => {
            this.$refs[errFieldName].setErrors(error[errFieldName])
          })
        })
    })
  }
}
